'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppBar = require('./AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AppBar2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/AppBar/index.js
// module id = 172
// module chunks = 0